import Layout from '@/views/layout'

export default [{
    path: '/PersonalCenter',
    component: Layout,
    redirect: '/salesMarketQuery/index',
    meta: {
        title: 'common.memberCenter'  //个人中心(业务查询)
    },
    children: [
        {
            path: 'meinfo-inquire/index',
            component: () => import('@/views/ay-personal-center/meinfo-inquire/index'),
            name: 'MeInfoInquire',
            meta: { title: 'user.information.inquiry' }  // 个人信息查询
        },
        {
            path: 'salesMarketQuery/index',
            component: () => import('@/views/ay-personal-center/salesMarketQuery/index'),
            name: 'SalesMarketQuery',
            meta: { title: 'mimember.mark.search' }  // 销售市场查询(注: 推荐)
        },
        {
            path: 'serviceMarketQuery/index',
            component: () => import('@/views/ay-personal-center/serviceMarketQuery/index'),
            name: 'ServiceMarketQuery',
            meta: { title: 'mimember.service.search' }  // 服务市场查询(注: 安置)
        },
        {
            path: 'agentBonusQuery/index',
            component: () => import('@/views/ay-personal-center/agentBonusQuery/index'),
            name: 'AgentBonusQuery',
            meta: { title: 'menu.bd.listBdBonusAgents' }  // 代办处奖金查询
        },
        {
            path: 'commissionQuery/index',
            component: () => import('@/views/ay-personal-center/commissionQuery/index'),
            name: 'CommissionQuery',
            meta: { title: 'mimember.bonus.search' }  // 佣金查询
        },
        {
            path: 'dealerProfile/index',
            component: () => import('@/views/ay-personal-center/dealerProfile/index'),
            name: 'DealerProfile',
            meta: { title: 'miMemberList.title' }  // 经销商资料管理维护（经销商）
        },
        {
            path: 'dealerPro/index',
            component: () => import('@/views/ay-personal-center/dealerPro/index'),
            name: 'DealerPro',
            meta: { title: 'member.memberInfoMgr' }  // 经销商资料管理维护（代办处）
        },
        {
            path: 'dealerPro/view',
            component: () => import('@/views/ay-personal-center/dealerPro/view'),
            name: 'DealerView',
            meta: { title: 'agent.memberInfoView' },  // 经销商资料详情（代办处）
            hidden: true
        },
        {
            path: 'agentProfile/index',
            component: () => import('@/views/ay-personal-center/agentProfile/index'),
            name: 'AgentProfile',
            meta: { title: 'agent.agentInfoMgr' }  // 代办处资料管理维护
        },
        {
            path: 'commissionForecast/index',
            component: () => import('@/views/ay-personal-center/commissionForecast/index'),
            name: 'CommissionForecast',
            meta: { title: 'bdbonus.pre.search' }  // 佣金预测
        },
        {
            path: 'changePassword/index',
            component: () => import('@/views/ay-personal-center/changePassword/index'),
            name: 'ChangePassword',
            meta: { title: 'title.change.password' }  // 更改密码
        },
        {
            path: 'performanceQuery/index',
            component: () => import('@/views/ay-personal-center/performanceQuery/index'),
            name: 'PerformanceQuery',
            meta: { title: 'miagent.member.sell' }  // 业绩查询
        },
        {
            path: 'realtimePerformanceQuery/index',
            component: () => import('@/views/ay-personal-center/realtimePerformanceQuery/index'),
            name: 'RealtimePerformanceQuery',
            meta: { title: 'real.time.query' }  // 实时业绩查询
        },

        {
            path: 'AgentReplenishmentQuantity',
            component: () => import('@/views/ay-personal-center/agentReplenishmentQuantity/index'),
            name: 'AgentReplenishmentQuantity',
            meta: { title: 'stStockWarehouseAgentList.title' }  // 代办处补货数量
        },
        {
            path: 'queryadvancedpoints/index',
            component: () => import('@/views/ay-personal-center/queryadvancedpoints/index'),
            name: 'QueryAdvancedPoints',
            meta: { title: '查询高级点位' }  // 查询高级点位
        }
    ]
}]
